import { createSlice } from '@reduxjs/toolkit';
import { collect } from 'collect.js';
import moment from 'moment-timezone';

export default createSlice({
  name: 'initialData',
  initialState: {
    companies: [],
    notifications: [],
    // Active languages, as reported by the API. Empty until initial data lands,
    // which the language registry reads as "offer everything this build ships".
    supported_languages: [],
    profile: {
      is_super_admin: false,
    },
    company_acl: [],
    franchise_acl: [],
    loading: false,
  },
  reducers: {
    set: (state, action) => {
      const { companies, notifications, profile, company_acl, franchise_acl, supported_languages } = action.payload;

      state.companies = companies;
      state.notifications = notifications;
      state.supported_languages = supported_languages ?? [];
      state.profile = profile;
      state.company_acl = company_acl;
      state.franchise_acl = franchise_acl;
    },
    resetProfile: (state) => {
      state.profile = { is_super_admin: false };
    },
    // Full reset for auth transitions — stale ACLs from a previous session
    // must never leak into the next user's permission context.
    reset: (state) => {
      state.companies = [];
      state.notifications = [];
      state.supported_languages = [];
      state.profile = { is_super_admin: false };
      state.company_acl = [];
      state.franchise_acl = [];
      state.loading = false;
    },
    updateCompanies: (state, action) => {
      state.companies = action.payload;
    },
    markNotificationsSeen: (state, action) => {
      try {
        state.notifications = collect(state.notifications)
          .transform((item) =>
            !action.payload.includes(item.id)
              ? item
              : {
                  ...item,
                  read_at: moment().format(),
                },
          )
          .toArray();
      } catch (error) {
        state.notifications = [];
      }
    },
    toggleLoading: (state) => {
      state.loading = !state.loading;
    },
  },
});
